goog.provide("shadow.js.shim.module$dayjs$locale$sk");
goog.provide("module$shadow_js_shim_module$dayjs$locale$sk");
shadow.js.shim.module$dayjs$locale$sk = shadow.js.nativeProvides["dayjs/locale/sk"] = require("dayjs/locale/sk");
module$shadow_js_shim_module$dayjs$locale$sk.default = shadow.js.shim.module$dayjs$locale$sk;
